import FupUserPagingResultModelBase from '../_generated/modelBases/fup-user-paging-result-model-base';

export default class FupUserPagingResultModel extends FupUserPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
